import { useLocation } from "react-router-dom";
import { regionFromPath, rlink } from "@/data/content";
import { useRegionPreference } from "@/hooks/RegionProvider";

// Returns current region id ("eu" | "ph") and a region-aware link builder.
export function useRegion() {
  const { pathname } = useLocation();
  const preference = useRegionPreference();
  const region = pathname === "/ph" || pathname.startsWith("/ph/") ? "ph" : preference.region;
  const link = (path) => rlink(region, path);
  return { region, link, isPH: region === "ph", regionSource: preference.source, setRegionPreference: preference.setRegionPreference };
}
